module.exports = __webpack_public_path__ + "img/pagination-new-icon.4d03658c.svg";